import moment from 'moment'
import * as defaultConst from './default_constants'

const publishCancelBasicSetup = {
  publish_date: {
    restriction: 'contract_time_restrictions',
    stage: 1
  },
  cancel_date: {
    restriction: 'contract_time_restrictions',
    stage: 2
  }
}

const validFromToBasicSetup = {
  valid_from: {
    minDate: moment(),
    minDateTimeStart: moment(moment().format(defaultConst.DATE_FORMAT) + defaultConst.DATE_TIME_UTC).utc(),
    minDateTimeEnd: moment(moment().format(defaultConst.DATE_FORMAT) + defaultConst.DATE_TIME_UTC_END).utc(),
    restriction: moment(),
    stage: 1
  },
  valid_to: {
    minDate: moment(),
    restriction: moment().subtract(1, 'day'),
    stage: 2
  }
}

const validFromToBasicSetup2 = {
  valid_from: {
    minDate: moment(),
    restriction: moment().subtract(1, 'day'),
    stage: 1
  },
  valid_to: {
    minDate: moment().subtract(1, 'day'),
    minDateToday: moment(),
    restriction: moment().subtract(2, 'day'),
    restrictionToday: moment().subtract(1, 'day'),
    stage: 2
  }
}

const validFromToBasicSetup3 = { // just remove checkbox if list_row is after valid_to (can't remove)
  valid_to: {
    restriction: moment().subtract(2, 'day'),
    restrictionToday: moment().subtract(1, 'day'),
    stage: 1
  }
}

export const timeRestrictionsSettings = {
  // entities
  flyprivate_categories_settings: validFromToBasicSetup3,
  flyprivate_categories_settings_manip: validFromToBasicSetup2,
  flyprivate_homepage_settings: validFromToBasicSetup2,
  vatrates: validFromToBasicSetup,
  flyprivate_pricing: { valid_from: validFromToBasicSetup.valid_from },
  pprolls: validFromToBasicSetup,
  pprolls_upload: validFromToBasicSetup,

  // subentities
  pricings: validFromToBasicSetup,
  pprolls_items: validFromToBasicSetup,

  // film edit - subentities:
  flyprivateCategories: validFromToBasicSetup2,
  flyprivate_video_pricing: validFromToBasicSetup,
  uploads: validFromToBasicSetup2,

  // subentities with contract_time_restrictions
  googleplayinfo: publishCancelBasicSetup,
  itunesinfo: publishCancelBasicSetup,
  youtubeinfo: publishCancelBasicSetup,

  youtube_asset_info: {
    asset_created_dt: {
      restriction: 'contract_time_restrictions',
      stage: 1
    }
  },

  // contracts
  costs: {
    due_date: {
      restriction: 'contract_time_restrictions',
      stage: 2
    },
    expire_date: {
      restriction: 'contract_time_restrictions',
      stage: 2
    }
  },

  // contract items
  rights: {
    start_license_period: {
      restriction: 'contract_time_restrictions',
      stage: 1
    },
    end_license_period: {
      restriction: 'contract_time_restrictions',
      stage: 2
    }
  },
  rights_costs: {
    due_date: {
      restriction: 'contract_time_restrictions',
      stage: 2
    },
    expire_date: {
      restriction: 'contract_time_restrictions',
      stage: 2
    }
  }
}
